<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <label>{{ $t("project_option.list") }}</label>
              <div>
                <lte-button
                  style="float:right;background-color:white !important; margin-right: 50px"
                  type="btn btn-default"
                  right_icon="fa fa-plus"
                  @click="addnew"
                >
                  {{ $t("advertise.addnew") }}
                </lte-button>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div>
              <b-table
                :per-page="perPage"
                :current-page="currentPage"
                striped
                hover
                :fields="fields"
                :items="advertiseprojectinfo"
              >
                <template slot="actions" slot-scope="row">
                  <div class="btn-group">
                    <button
                      @click="onhandleEdit(row)"
                      class="btn btn-primary"
                      style="margin-left: 6px"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                    <button
                      @click="onhandleDelete(row)"
                      class="btn btn-danger"
                      style="margin-left: 6px"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                size="sm"
                class="mt-0"
              ></b-pagination>
            </div>
            <div class="modal fade" :ref="`modal-pkg-tp`">
              <div class="modal-dialog">
                <confirm :id="pkg_tp_data.id" @confirm="onDeleteConfirm" />
              </div>
            </div>
            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              color="#1E90FF"
            ></loading>
            <lte-core-alert
              v-for="snackbar in GET_SNACK_BAR"
              :key="snackbar.id"
              :item="snackbar"
            ></lte-core-alert>
          </div>
        </div>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
import Confirm from "@/components/Confirm.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import loading from "vue-loading-overlay";
import utils from '@/lib/utils'

export default {
  name: "AdvertiseProjectInforList",
  data() {
    return {
      advertiseprojectinfo: [],
      currentPage: 1,
      totalRows: 1,
      isLoading: false,
      perPage: 50,
      pkg_tp_data: {
        id: 0
      },
      fields: [
        {
          key: "STT",
          label: this.$t("common.nonumber"),
          class: "text-center",
          tdClass: "stt"
        },
        {
          key: "name",
          label: this.$t("project_option.project_name"),
          class: "text-center"
        },
        {
          key: "date_created",
          label: this.$t("project_option.project_created"),
          class: "text-center"
        },
        {
          key: "active",
          label: this.$t("project_option.project_active"),
          class: "text-center"
        },
        {
          key: "actions",
          label: this.$t("project_option.project_actions"),
          class: "actions_style"
        }
      ]
    };
  },
  watch: {
    GET_ADVERTISE_DATA_PROJECT_INFO_DATA: function() {
      this.advertiseprojectinfo = [];
      this.GET_ADVERTISE_DATA_PROJECT_INFO_DATA.forEach((ad_pro_inf, idx) => {
        let data = {
          STT: idx + 1,
          name: ad_pro_inf.project_name,
          id: ad_pro_inf.id,
          date_created: utils.formatSqlDate(ad_pro_inf.date_created, null, "DD-MM-YYYY"),
          active: ad_pro_inf.active == true ? "Đã Kích Hoạt" : "Chưa Kích Hoạt"
        };
        this.advertiseprojectinfo.push(data);
      });
      this.totalRows = this.advertiseprojectinfo.length;
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ADVERTISE_DATA_PROJECT_INFO_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_ADVERTISE_DATA_PROJECT_INFO",
      "DELETE_ADVERTISE_PROJECT_INFORMATION",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST"
    ]),
    addnew() {
      this.$router.push({
        name: "AdvertiseProjectInfoAdd",
        params: {
          id: 0
        }
      });
    },
    onhandleDelete: function(row) {
      this.pkg_tp_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tp`]).modal(action);
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      };
      this.isLoading = true;
      this.DELETE_ADVERTISE_PROJECT_INFORMATION(payload)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.templateEmaillist == 1
                ? totalPage >= 2
                  ? totalPage - 1
                  : 1
                : currentPage;
            const data = {
              params: {
                page: page
              }
            };
            this.GET_ADVERTISE_DATA_PROJECT_INFO(data);
            this.isLoading = false;
            $(this.$refs[`modal-pkg-tp`]).modal("hide");
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
            $(this.$refs[`modal-pkg-tp`]).modal("hide");
          }.bind(this)
        );
    },
    onhandleEdit: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "AdvertiseProjectInfoAdd",
        params: {
          id: id
        }
      });
    }
  },
  mounted() {
    this.GET_ADVERTISE_DATA_PROJECT_INFO();
  },
  components: {
    confirm: Confirm,
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    loading: loading
  }
};
</script>
<style>
.actions_style {
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Advertise/AdvertiseProjectInfoList.vue